// Scene 1 — goons approach (slow zoom), sharp cut to eyes, white → black,
// silence, Intake Mind's first line.
//
// ASSET SLOTS — replace '' with import paths once assets land:
//   import goons from "../assets/goons.png";  → FRAME_GOONS
//   import eyes  from "../assets/eyes.png";   → FRAME_EYES
//
// Until assets land the gradient placeholders in act2.css are active.

import _goons from "../assets/goons.png";
import _eyes  from "../assets/scared-eyes.png";

const FRAME_GOONS = _goons;
const FRAME_EYES  = _eyes;

const GOONS_ZOOM_MS = 3200;

const MIND_FIRST_LINE = "Don't worry — we've got you. You're safe now.";

export function runCutscene(root: HTMLElement): Promise<void> {
  return new Promise((resolve) => {
    root.innerHTML = "";
    root.className = "act2-cutscene";

    const frame   = el("div", "cs-frame");
    const overlay = el("div", "cs-overlay");
    const caption = el("div", "cs-caption");
    const prompt  = el("div", "cs-prompt");
    prompt.textContent = "[ click or press space to continue ]";

    root.append(frame, overlay, caption, prompt);

    async function run() {
      // ── Goons: slow zoom ─────────────────────────────────────
      frame.dataset.label = "goons";
      if (FRAME_GOONS) frame.style.backgroundImage = `url("${FRAME_GOONS}")`;
      frame.classList.add("cs-zooming");
      await wait(GOONS_ZOOM_MS);

      // ── Sharp cut to eyes → fade to white → snap to black ────
      frame.classList.remove("cs-zooming");
      frame.dataset.label = "eyes";
      frame.style.backgroundImage = FRAME_EYES ? `url("${FRAME_EYES}")` : "";

      await wait(2500); // hold on the eyes

      overlay.classList.add("to-white");
      await wait(500); // white fades in over 0.4s + brief hold

      overlay.classList.replace("to-white", "to-black"); // instant snap
      await wait(150);

      frame.dataset.label = "black";
      frame.style.backgroundImage = "";

      // ── Act title — shown during the black silence ────────────
      await wait(600);
      const actTitle = el("div", "cs-act-title");
      actTitle.innerHTML = `<p class="act3-eyebrow">— ACT 2 —</p><h1 class="act3-title">Where's My Body?</h1>`;
      root.append(actTitle);
      await wait(80);
      actTitle.classList.add("act3-in");
      await wait(2000);
      actTitle.classList.remove("act3-in");
      await wait(1000);
      root.removeChild(actTitle);

      // ── Voice line ────────────────────────────────────────────
      caption.textContent = MIND_FIRST_LINE;
      caption.classList.add("visible");

      await wait(700);
      prompt.classList.add("visible");

      await waitForAdvance(root);
      resolve();
    }

    run();
  });
}

function waitForAdvance(root: HTMLElement): Promise<void> {
  return new Promise((r) => {
    function done() {
      root.removeEventListener("click", done);
      document.removeEventListener("keydown", onKey);
      r();
    }
    function onKey(e: KeyboardEvent) {
      if (e.key === " " || e.key === "Enter" || e.key === "ArrowRight") done();
    }
    root.addEventListener("click", done, { once: true });
    document.addEventListener("keydown", onKey);
  });
}

function wait(ms: number): Promise<void> {
  return new Promise((r) => setTimeout(r, ms));
}

function el(tag: string, className: string): HTMLElement {
  const e = document.createElement(tag);
  e.className = className;
  return e;
}
